import React, { useEffect, useMemo } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Formik } from "formik";

import { useActionHook, useModals } from "../../../hooks";
import { useDealActions } from "../../../store";
import { ICreateInvestorData } from "../../../store/types";
import { IInvestorModal } from "../../../store/types/modals";
import { InvestorsForm } from "./Investors-form/InvestorsForm";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
};

export const CreateInvestorModal: React.FC<IInvestorModal> = ({ isOpen, initialName, getInvestor }) => {
  const { closeInvestorModal } = useModals();

  const { createInvestorAction } = useDealActions();
  const { action, error } = useActionHook(createInvestorAction, {
    onSuccess: (res) => {
      closeInvestorModal();
      getInvestor?.(res);
    }
  });

  useEffect(() => {
    if (!isOpen) {
      delete error?.errors;
    }
  }, [isOpen]);

  const initialValues: ICreateInvestorData = useMemo(
    () => ({
      name: initialName || "",
      group: "",
      phone_number: "",
      email: "",
      company: "",
      additional_information: "",
      description: null
    }),
    [initialName]
  );

  const onSubmit = async (values: ICreateInvestorData) => {
    const investorData: ICreateInvestorData & { id?: number } = {
      name: values.name,
      group: values.group,
      email: values.email,
      phone_number: values.phone_number,
      company: values.company,
      additional_information: values.additional_information,
      description: values.description
    };
    action(investorData);
  };

  const addInvestorsForm = useMemo(() => {
    return (
      <Formik onSubmit={onSubmit} initialValues={initialValues} enableReinitialize>
        {({ values, handleChange }) => {
          return (
            <Stack sx={{ padding: "34px 50px 10px 40px", flexGrow: 1 }}>
              <form className="create-investor__modal-body">
                <InvestorsForm
                  addInvestorError={error?.errors}
                  onCancel={closeInvestorModal}
                  handleSubmit={onSubmit}
                  values={values}
                  handleChange={handleChange}
                />
              </form>
            </Stack>
          );
        }}
      </Formik>
    );
  }, [initialValues, onSubmit, error, closeInvestorModal]);
  return (
    <Modal open={isOpen} onClose={closeInvestorModal}>
      <Box sx={style}>
        <Stack
          sx={{
            width: 600,
            flexGrow: 1,
            backgroundColor: "white",
            borderRadius: "10px"
          }}
          direction="column"
        >
          <Box sx={{ background: "#fff", borderRadius: "10px 10px 0px 0px", padding: "30px 30px 0 30px" }}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ borderBottom: "1px solid  #DAE0E2", paddingBottom: "5px" }}
            >
              <span>ADD INVESTOR</span>
              <IconButton onClick={closeInvestorModal}>
                <CloseIcon className="icon" />
              </IconButton>
            </Stack>
          </Box>
          {addInvestorsForm}
        </Stack>
      </Box>
    </Modal>
  );
};
